module.exports = __webpack_public_path__ + "img/icon-category-camper.1f636bed.png";